var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { Panel, PanelType, DefaultButton, PrimaryButton } from '../../fluent';
import { StringResources } from '../helpers/strings';
export class Wizard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            children: props.children || [],
            currentPage: props.currentPage || 0,
            finishButtonDisabled: props.finishButtonDisabled || false,
            finishButtonText: props.finishButtonText,
            fullScreen: props.fullScreen,
            nextButtonDisabled: props.nextButtonDisabled || false,
            show: props.show,
            title: props.title
        };
    }
    componentWillReceiveProps(props) {
        this.setState({
            children: props.children || [],
            currentPage: props.currentPage || 0,
            finishButtonDisabled: props.finishButtonDisabled || false,
            finishButtonText: props.finishButtonText,
            fullScreen: props.fullScreen,
            nextButtonDisabled: props.nextButtonDisabled || false,
            show: props.show,
            title: props.title
        });
    }
    render() {
        const children = this.state.children.filter((_, index) => index === this.state.currentPage);
        return React.createElement(Panel, { isOpen: this.state.show, hasCloseButton: false, type: this.props.fullScreen ? PanelType.smallFluid : PanelType.large, headerText: this.state.title, isFooterAtBottom: true, onRenderFooterContent: () => React.createElement("div", { className: 'ms-Grid-row' },
                React.createElement("div", { className: 'ms-Grid-col ms-u-sm12', style: { textAlign: 'right', userSelect: 'none' } },
                    React.createElement(DefaultButton, { disabled: this.state.currentPage === 0, iconProps: { iconName: 'ChevronLeft' }, onClick: this._back.bind(this), text: StringResources.Back }),
                    React.createElement("span", null, "\u00A0\u00A0"),
                    React.createElement(DefaultButton, { disabled: this.state.nextButtonDisabled || (this.state.currentPage === this.state.children.length - 1), iconProps: { iconName: 'ChevronRight' }, onClick: this._next.bind(this), text: StringResources.Next }),
                    React.createElement("span", null, "\u00A0\u00A0"),
                    React.createElement(PrimaryButton, { disabled: this.state.finishButtonDisabled || (this.state.currentPage < this.state.children.length - 1), iconProps: { iconName: 'Accept' }, onClick: this._finish.bind(this), primary: true, text: this.state.finishButtonText || StringResources.Finish }),
                    React.createElement("span", null, "\u00A0\u00A0"),
                    React.createElement(DefaultButton, { iconProps: { iconName: 'Cancel' }, onClick: this._cancel.bind(this), text: StringResources.Cancel }))), closeButtonAriaLabel: 'Cerrar' },
            React.createElement(React.Fragment, null, children));
    }
    _back() {
        if (this.state.currentPage > 0) {
            this.props.onChangePage(this.state.currentPage - 1);
        }
    }
    _next() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.state.currentPage < this.state.children.length) {
                this.props.onChangePage(this.state.currentPage + 1);
            }
        });
    }
    _finish() {
        if (this.props.onFinish) {
            this.props.onFinish();
        }
    }
    _cancel() {
        if (this.props.onCancel) {
            this.props.onCancel();
        }
    }
}
